import createReactClass from "create-react-class";
import update from "immutability-helper";
import React from "react";
import { Button } from "react-bootstrap";
import DateTime from "react-datetime";
import { ErrorAction } from "../actions/errorActions";
import { FormRequestActions } from "../actions/formRequestActions";
import { ServerActions } from "../actions/serverActions";
import { ConfirmationModalActions } from "../actions/submissionConfirmationModalActions";
import { TabActions } from "../actions/tabActions";
import { InformationRadiatorView } from "../components/informationRadiator";
import { SubdivisionLocationList } from "../components/subdivisionLocationList";
import { SubmissionConfirmationModal } from "../components/submissionConfirmationModal";
import Constants from "../constants/constants";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { schematicStore } from "../stores/schematic";
import { subdivisionStore } from "../stores/subdivision";
import { tabsStore } from "../stores/tabs";
import { userStore } from "../stores/user";
import { formValidation } from "../util/formValidation";
import { ModalError } from "./modalError";
var STATUS = Constants.RestrictionStatuses;
var TYPES = Constants.RestrictionTypes;

//function to get state from store, getting the currently loaded restriction
function getStateFromStores() {
  return {
    collapsed: tabsStore.isCollapsed(),
    restriction: restrictionRequestStore.getForm(),
    isModifying: restrictionRequestStore.isModifying(),
    isDirty: restrictionRequestStore.isDirty(),
    readOnly: restrictionRequestStore.getReadOnly(),
    partialReadOnly: restrictionRequestStore.getPartialReadOnly(),
    errors: restrictionRequestStore.getErrors(),
    touchedFields: restrictionRequestStore.getTouchedFields(),
    formType: restrictionRequestStore.getFormType(),
    user: userStore.getSelectedRole(),
    printLata: userStore.getLata(),
    clickedItem: subdivisionStore.getSelectedSub(),
    showSubDropDown: restrictionRequestStore.getShowSubDropDown(),
    textValue: "",
    subdivisionSelected: subdivisionStore.isSubSelected(),
    subData: subdivisionStore.getSubData(),
    selectableSubList: subdivisionStore.getSubList(),
    entireSubList: subdivisionStore.getEntireSubList(),
    previousSub: "",
    showFromLocations: restrictionRequestStore.getShowFormTCMFromLocations(),
    fromLocationSuggestion: restrictionRequestStore.getFromLocationSuggestion(),
    showToLocations: restrictionRequestStore.getShowFormTCMToLocations(),
    toLocationSuggestion: restrictionRequestStore.getToLocationSuggestion(),
    disableMps: restrictionRequestStore.getDisableFormCMps(),
    disableLocations: restrictionRequestStore.getDisableFormCLocations(),
    disableSubSelection: restrictionRequestStore.getDisableFormCSubSelection(),
    disableEntireSub: restrictionRequestStore.getDisableFormCEntireSub(),
    disableAllSubs: restrictionRequestStore.getDisableFormCAllSubs(),
    mpTitle: restrictionRequestStore.getFormCMpTitle(),
    locTitle: restrictionRequestStore.getFormCLocTitle(),
    subSelectionTitle: restrictionRequestStore.getFormCSubDropDownTitle(),
    entireSubTitle: restrictionRequestStore.getFormCEntireSubTitle(),
    entireSubChecked: restrictionRequestStore.getFormCEntireSubChecked(),
  };
}

export const TCMFormView = createReactClass({
  componentDidMount: function () {
    restrictionRequestStore.subscribe(this._onChange);
    subdivisionStore.subscribe(this._onChange);
    userStore.subscribe(this._onChange);
    tabsStore.subscribe(this._onChange);
    schematicStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    restrictionRequestStore.unsubscribe(this._onChange);
    subdivisionStore.unsubscribe(this._onChange);
    userStore.unsubscribe(this._onChange);
    tabsStore.unsubscribe(this._onChange);
    schematicStore.unsubscribe(this._onChange);
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  getInitialState: function () {
    let newState = getStateFromStores();
    newState.subSelectionTitle =
      "Clear Location/MP values to select multiple subdivisions";
    return newState;
  },

  getFormattedDate: function (date) {
    var dateVal =
      ("0" + (parseInt(date.getMonth()) + 1)).slice(-2) +
      ("0" + date.getDate()).slice(-2) +
      date.getFullYear().toString().substr(2, 2);
    return dateVal;
  },
  changeConditionPermanent: function (event) {
    var target = event.target.checked;
    var vals = {};
    vals[target] = { $set: event.target.checked };
    var newState = update(this.state, {
      restriction: vals,
    });
    this.setState(newState);

    FormRequestActions.formFieldChanged(newState.restriction, target);

    FormRequestActions.tcmConditionPermanentChange(event.target.checked);
  },
  changeTcmPrint: function (event) {
    var target = event.target.checked;
    var vals = {};
    vals[target] = { $set: event.target.checked };
    var newState = update(this.state, {
      restriction: vals,
    });
    this.setState(newState);

    FormRequestActions.formFieldChanged(newState.restriction, target);

    FormRequestActions.tcmPrintChange(event.target.checked);
  },
  changeText: function (e) {
    FormRequestActions.tcmTextChanged(e.target.value);
  },
  voidRestriction: function (event) {
    var state = this.state;
    const title = "Confirm Void of " + state.restriction.controlNumber;
    const body =
      "Are you sure you want to void restriction " +
      state.restriction.controlNumber +
      "?";
    if (this.state.isDirty && this.state.formType === TYPES.TCM) {
      ErrorAction.showModalError(
        "Values on the restriction have been modified. Please reload the form to void"
      );
    } else {
      window
        .confirm(title, {
          description: body,
          confirmLabel: "Void",
          abortLabel: "Go Back",
        })
        .then(function () {
          ServerActions.submitItemToServer({
            action: Constants.restrictionActions.VOID_RESTRICTION,
            printLata: state.printLata,
            id: state.restriction.requestId,
            requestToSubmit:
              restrictionRequestStore.restrictionFormattedForSubmission(),
          });
        });
    }
  },
  updateTCM: function () {
    ServerActions.submitItemToServer({
      action: Constants.restrictionActions.MODIFY_RESTRICTION,
      printLata: this.state.printLata,
      requestToSubmit:
        restrictionRequestStore.restrictionFormattedForSubmission(),
    });
  },

  formTCMDT: function () {
    ServerActions.submitItemToServer({
      action: Constants.restrictionActions.TCMDT_RESTRICTION,
      printLata: this.state.printLata,
      requestToSubmit:
        restrictionRequestStore.restrictionFormattedForSubmission(),
    });
  },
  clearForm: function (event) {
    var me = this;
    window
      .confirm("Clear", {
        description:
          "Selecting Clear will abandon all your current work. Are you sure you want to do this?",
        confirmLabel: "Clear",
        abortLabel: "Go Back",
      })
      .then(function () {
        FormRequestActions.reset();
      });
  },
  backToIssueList: function (event) {
    if (this.state.isDirty) {
      window
        .confirm("Return to Issue List", {
          description:
            "Selecting Issue List will abandon all your current work and return you to the restriction list. Are you sure you want to do this?",
          confirmLabel: "Issue List",
          abortLabel: "Go Back",
        })
        .then(function () {
          TabActions.changeTab(1, "tcm");
        });
    } else {
      TabActions.changeTab(1, "tcm");
    }
  },
  onChange: function (event) {
    let regex = /^[\s\S]+$/;
    if (
      event.target.id === "workStartMpSuffix" ||
      event.target.id === "workEndMpSuffix"
    ) {
      regex = /^[a-zA-Z\b]+$/;
    } else if (
      event.target.id === "workStartMp" ||
      event.target.id === "workEndMp"
    ) {
      regex = /^[0-9.\b]+$/;
    }
    if (event.target.value === "" || regex.test(event.target.value)) {
      var target = event.target.id;
      var vals = {};
      vals[target] = { $set: event.target.value.toUpperCase() };
      var newState = update(this.state, {
        restriction: vals,
      });
      this.setState(newState);

      FormRequestActions.formFieldChanged(newState.restriction, target);
    }
  },
  updateDateState: function (fieldName, event) {
    var vals = {};

    var dateVal;
    if (event._d !== undefined) {
      dateVal = this.getFormattedDate(event._d);
    } else {
      dateVal = event;
    }
    vals[fieldName] = { $set: dateVal };
    var newState = update(this.state, {
      restriction: vals,
    });
    this.setState(newState);
    FormRequestActions.dateFieldChanged(
      this.state.restriction,
      fieldName,
      dateVal
    );
    FormRequestActions.formFieldBlurred(this.state.restriction, fieldName);
  },

  onExpireDateChange: function (event) {
    this.updateDateState("estimatedRemovalDate", event);
  },

  onEstRemovalBlur: function (event) {
    this.updateDateState("estimatedRemovalDate", event);
  },

  onEstRemovalFocus: function (event) {
    setTimeout(function () {
      $("#expectDate .dateInput").blur();
      $("#expectDate .dateInput").focus();
    }, 10);
  },
  onLocationChange: function (event) {
    if (event.target.value || event.target.value === "") {
      var target = event.target.id;
      var vals = {};
      vals[target] = { $set: event.target.value.toUpperCase() };
      var newState = update(this.state, {
        restriction: vals,
      });
      this.setState(newState);

      FormRequestActions.formFieldChanged(newState.restriction, target);
    }
  },
  onFromLocationFocus: function (e) {
    let locations = restrictionRequestStore.getSubLocations();
    if (locations && locations.length === 0) {
      //If there are no location, get them from the server
      FormRequestActions.requestSubdivisionLocations(
        this.state.restriction.subdivision
      );
    }
    FormRequestActions.toggleShowFormTCMFromLocations(true);
    FormRequestActions.toggleShowFormTCMToLocations(false);
  },
  onToLocationFocus: function (e) {
    let locations = restrictionRequestStore.getSubLocations();
    if (locations && locations.length === 0) {
      //If there are no location, get them from the server
      FormRequestActions.requestSubdivisionLocations(
        this.state.restriction.subdivision
      );
    }
    FormRequestActions.toggleShowFormTCMToLocations(true);
    FormRequestActions.toggleShowFormTCMFromLocations(false);
  },
  onBlur: function (e) {
    FormRequestActions.formFieldBlurred(this.state.restriction, e.target.id);
  },
  onFromLocationBlur: function (e) {
    let target = e.relatedTarget;

    if (target === null) {
      target = document.activeElement;
    }
    if (target.parentElement.id === "locationTable") {
      //No-op. If this is a child of locatonTable, the user is clicking on a location in the list
    } else {
      FormRequestActions.toggleShowFormTCMFromLocations(false);
      FormRequestActions.formFieldBlurred(
        this.state.restriction,
        "fromLocation"
      );
    }
  },

  onToLocationBlur: function (e) {
    let target = e.relatedTarget;

    if (target === null) {
      target = document.activeElement;
    }
    if (target.parentElement.id === "locationTable") {
      //No-op. If this is a child of locatonTable, the user is clicking on a location in the list
    } else {
      FormRequestActions.toggleShowFormTCMToLocations(false);
      FormRequestActions.formFieldBlurred(this.state.restriction, "toLocation");
    }
  },

  onInputFocus: function () {
    FormRequestActions.toggleShowFormTCMFromLocations(false);
    FormRequestActions.toggleShowFormTCMToLocations(false);
  },

  issueFormTCM: function () {
    var canSubmit = restrictionRequestStore.formValid();
    if (!canSubmit) {
      ConfirmationModalActions.validateBeforeSubmitting();
    } else {
      ServerActions.submitItemToServer({
        action: Constants.restrictionActions.ISSUE_RESTRICTION,
        printLata: this.state.printLata,
        requestToSubmit:
          restrictionRequestStore.restrictionFormattedForSubmission(),
      });
    }
  },

  render: function () {
    let restriction = this.state.restriction;
    let isReadOnly = this.state.readOnly;
    let disableMps = this.state.disableMps;
    let disableLocations = this.state.disableLocations;
    let disableEntire = this.state.disableEntireSub;
    let disableSubmit = false;
    let showFromLocations = this.state.showFromLocations;
    let fromSuggestion = this.state.fromLocationSuggestion;
    let showToLocations = this.state.showToLocations;
    let toSuggestion = this.state.toLocationSuggestion;
    let validRanges = determineValidRanges(this.state.subData);
    let restrictionText = this.state.restriction.comments;
    let isFieldUser = false;
    let TCMDtChangeComment = "";

    //Check if they are read only
    if (this.state.user.indexOf(Constants.Roles.READ_ONLY) === 0) {
      isReadOnly = true;
    }

    if (this.state.user.indexOf(Constants.Roles.FIELD_USER) === 0) {
      isFieldUser = true;
      if (
        restriction.formTCMDTChangeComment !== "" &&
        restriction.formTCMDTChangeComment !== undefined &&
        restriction.formTCMDTChangeComment !== null
      )
        TCMDtChangeComment =
          "TCMDT Change Comment: " + restriction.formTCMDTChangeComment;
    }
    if (this.state.restriction.comments) {
      let sortedText = this.state.restriction.comments.sort(function (c1, c2) {
        return sortFunction(c1, c2);
      });

      let text = sortedText.map(function (line) {
        return line.comment;
      });

      restrictionText = text.join("\n");
    }

    var fromMP = (
      <div className={"topRow"}>
        <label>*From MP:</label>
        <br />
        <input
          type="text"
          disabled={isReadOnly || disableMps || isFieldUser}
          id="workStartMp"
          className="mpInput"
          name="fromMp"
          placeholder="xxxx.x"
          title={disableMps ? this.state.mpTitle : ""}
          value={restriction.workStartMp}
          onChange={this.onChange}
          onBlur={this.onBlur}
          pattern={formValidation.regex.mpRegex}
          maxLength="6"
          required
        />
        <input
          type="text"
          disabled={isReadOnly || disableMps || isFieldUser}
          title={disableMps ? this.state.mpTitle : ""}
          id="workStartMpSuffix"
          name="fromMpSuffix"
          className="suffixInput"
          value={restriction.workStartMpSuffix}
          onChange={this.onChange}
          onBlur={this.onBlur}
          pattern={formValidation.regex.suffixRegex}
          maxLength="1"
        />
        <span
          className="glyphicon glyphicon-question-sign"
          title={validRanges}
        />
      </div>
    );
    var toMP = (
      <div className={"topRow"}>
        <label>*To MP:</label>
        <br />
        <input
          type="text"
          disabled={isReadOnly || disableMps || isFieldUser}
          id="workEndMp"
          className="mpInput"
          placeholder="xxxx.x"
          title={disableMps ? this.state.mpTitle : ""}
          name="toMp"
          value={restriction.workEndMp}
          onChange={this.onChange}
          onBlur={this.onBlur}
          pattern={formValidation.regex.mpRegex}
          maxLength="6"
          required
        />
        <input
          type="text"
          disabled={isReadOnly || disableMps || isFieldUser}
          title={disableMps ? this.state.mpTitle : ""}
          id="workEndMpSuffix"
          name="toMpSuffix"
          value={restriction.workEndMpSuffix}
          onChange={this.onChange}
          onBlur={this.onBlur}
          className="suffixInput"
          maxLength="1"
          pattern={formValidation.regex.suffixRegex}
        />
      </div>
    );

    let displayFromLocations = "none";
    if (showFromLocations) {
      displayFromLocations = "";
    }

    var fromLocation = (
      <div id="fromLocationTCM" className={"topFromToAuthorized"}>
        <label>From Location:</label>
        <br />
        <div>
          <input
            type="text"
            value={fromSuggestion}
            disabled={isReadOnly || disableLocations || isFieldUser}
            className="locationInput"
            id="fromLocationSuggestion"
            tabIndex="-1"
          />
          <input
            type="text"
            disabled={isReadOnly || disableLocations || isFieldUser}
            title={disableLocations ? this.state.locTitle : ""}
            value={restriction.fromLocation}
            onChange={this.onLocationChange}
            onBlur={this.onFromLocationBlur}
            onFocus={this.onFromLocationFocus}
            id="fromLocation"
            className="locationInput"
            name="fromLocation"
            maxLength="20"
            required
          />
        </div>
        <div
          id="subdivisionLocations"
          style={{ display: displayFromLocations }}
        >
          <SubdivisionLocationList locationType="from" />
        </div>
      </div>
    );

    let displayToLocations = "none";
    if (showToLocations) {
      displayToLocations = "";
    }
    var toLocation = (
      <div id="toLocationTCM" className={"topFromToAuthorized"}>
        <label>To Location:</label>
        <br />
        <div>
          <input
            type="text"
            value={toSuggestion}
            disabled={isReadOnly || disableLocations || isFieldUser}
            className="locationInput"
            id="toLocationSuggestion"
            tabIndex="-1"
          />
          <input
            type="text"
            disabled={isReadOnly || disableLocations || isFieldUser}
            title={disableLocations ? this.state.locTitle : ""}
            value={restriction.toLocation}
            onChange={this.onLocationChange}
            onBlur={this.onToLocationBlur}
            onFocus={this.onToLocationFocus}
            id="toLocation"
            className="locationInput"
            name="toLocation"
            maxLength="20"
            required
          />
        </div>
        <div id="subdivisionLocations" style={{ display: displayToLocations }}>
          <SubdivisionLocationList locationType="to" />
        </div>
      </div>
    );

    var authorizedBy = (
      <div className={"topFromToAuthorized"}>
        <label>Authorized By* :</label>
        <br />
        <input
          type="text"
          disabled={isReadOnly || isFieldUser}
          onFocus={this.onInputFocus}
          value={restriction.authorizedBy}
          onChange={this.onChange}
          onBlur={this.onBlur}
          id="authorizedBy"
          className="requestedInput"
          name="authorizedBy"
          maxLength="22"
          required
        />
      </div>
    );

    var estimatedRemoval = (
      <div className={"topFromToAuthorized"}>
        <label>Est Removal* :</label>
        <br />
        <div title={TCMDtChangeComment} id="expectDate">
          <DateTime
            type="text"
            value={
              restriction.permanentIndicator === "N"
                ? restriction.estimatedRemovalDate
                : ""
            }
            id="estimatedRemovalDate"
            ref="estimatedRemovalDate"
            dateFormat="MMDDYY"
            timeFormat={false}
            closeOnSelect={true}
            onFocus={this.onEstRemovalFocus}
            onChange={this.onExpireDateChange}
            onBlur={this.onEstRemovalBlur}
            inputProps={{
              placeholder: "MMDDYY",
              disabled: isReadOnly | (restriction.permanentIndicator === "Y"),
              className: "dateInput",
            }}
          />
        </div>
      </div>
    );

    function renderIssueButton(that) {
      let button = "";
      if (that.state.restriction.status === STATUS.ISSUED) {
        if (that.state.user.indexOf(Constants.Roles.DISPATCHER) > -1) {
          button = (
            <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
              <span>
                <SubmissionConfirmationModal
                  buttonText={"Modify Restriction"}
                  submitAction={that.updateTCM}
                  form={restriction}
                  disabled={!that.state.isDirty}
                  question={
                    "modify restriction " + that.state.restriction.controlNumber
                  }
                  modified={that.state.isDirty}
                  read={{ only: that.state.isReadOnly }}
                />
              </span>
            </div>
          );
        } else if (isFieldUser) {
          button = (
            <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
              <span>
                <SubmissionConfirmationModal
                  buttonText={"Modify Restriction"}
                  submitAction={that.formTCMDT}
                  form={restriction}
                  disabled={!that.state.isDirty}
                  question={
                    "modify restriction " + that.state.restriction.controlNumber
                  }
                  modified={that.state.isDirty}
                  read={{ only: that.state.isReadOnly }}
                />
              </span>
            </div>
          );
        } else {
          button = "";
        }
      } else {
        button = (
          <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
            <span>
              <SubmissionConfirmationModal
                buttonText={"Issue Restriction"}
                submitAction={that.issueFormTCM}
                form={restriction}
                disabled={disableSubmit}
                question={"issue this restriction"}
                modified={that.state.isDirty}
                read={{ only: false, partial: false }}
              />
            </span>
          </div>
        );
      }

      return button;
    }

    function renderResetButton(that) {
      let button = "";

      if (isFieldUser || that.state.restriction.status === STATUS.ISSUED) {
        button = (
          <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
            <Button
              bsStyle="warning"
              id="resetButton"
              onClick={that.backToIssueList}
            >
              Back
            </Button>
          </div>
        );
      } else {
        button = (
          <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
            <Button bsStyle="warning" id="resetButton" onClick={that.clearForm}>
              Clear
            </Button>
          </div>
        );
      }

      return button;
    }

    let condChkBox = (
      <label>
        Condition Permanent
        <input
          type="checkbox"
          disabled={isReadOnly}
          checked={restriction.permanentIndicator === "Y"}
          id="condPermBox"
          name="condPermBox"
          onChange={this.changeConditionPermanent}
        />
      </label>
    );

    let infoRad = "infoRadShown";
    function voidRestrictionButton(that) {
      if (that.state.restriction.status === STATUS.ISSUED) {
        if (that.state.user.indexOf(Constants.Roles.DISPATCHER) > -1) {
          var button = (
            <Button
              style={{ position: "relative", left: "15px" }}
              bsStyle="danger"
              id="voidFormBRestriction"
              onClick={that.voidRestriction}
              disabled={that.state.batchMode}
            >
              Void Restriction
            </Button>
          );
        }
        return button;
      }
    }
    var content = (
      <div
        id="create-TCMRestriction"
        className="content scaffold-create"
        role="main"
      >
        <form name="TCMform" autoComplete="off">
          <fieldset className="form">
            <div id="controlLayoutGrid" className="container">
              <div className="row">
                {/*entire form row*/}
                <div className="gridRowPadding row">
                  <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                    {fromMP}
                    {toMP}
                    {fromLocation}
                    {toLocation}
                    {authorizedBy}
                    {estimatedRemoval}
                  </div>
                  <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    {renderIssueButton(this)}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="gridRowPadding row">
                  <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10"></div>
                  <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    {voidRestrictionButton(this)}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="gridRowPadding row">
                  <div className={"col-xs-3 col-sm-3 col-md-3 col-lg-3"}></div>
                  <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
                    <label>
                      Print Desk Copy
                      <input
                        type="checkbox"
                        disabled={isReadOnly || disableEntire || isFieldUser}
                        checked={restriction.printIndicator === "Y"}
                        id="printTCMBox"
                        name="printTCMBox"
                        onChange={this.changeTcmPrint}
                      />
                    </label>
                  </div>
                  <div className={"col-xs-5 col-sm-5 col-md-5 col-lg-5"}>
                    {condChkBox}
                  </div>
                  <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
                    {renderResetButton(this)}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="gridRowPadding row">
                  <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}></div>
                  <div className={"col-xs-5 col-sm-5 col-md-5 col-lg-5"}>
                    <label>*Text:</label>
                    <br />
                    <textarea
                      id="TCMText"
                      rows={20}
                      disabled={isReadOnly || disableEntire || isFieldUser}
                      cols={Constants.MaxValues.MAX_TCM_LINE_LENGTH}
                      value={restrictionText}
                      onChange={this.changeText}
                      onBlur={this.onBlur}
                    />
                  </div>
                  <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}></div>
                  <div
                    className={"col-xs-3 col-sm-3 col-md-3 col-lg-3"}
                    style={{ paddingTop: "25px" }}
                  >
                    <div id="informationRadiatorOuterDivfc" className={infoRad}>
                      <InformationRadiatorView />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    );

    var formID = "TCMform";

    if (!this.state.subdivisionSelected) {
      var style = {
        fontWeight: "bold",
        marginLeft: "10px",
        marginTop: "10px",
        fontSize: "x-large",
      };

      return <div style={style}>Please select a subdivision</div>;
    }
    //build up the form and bind the values
    return (
      <div id={formID}>
        {content}
        {<ModalError />}
      </div>
    );
  },
});

function determineValidRanges(subData) {
  if (
    subData &&
    subData.milePostRangeList &&
    subData.milePostRangeList.length > 0
  ) {
    var strings = subData.milePostRangeList.map(function (range) {
      return (
        range.from +
        (range.sfx ? range.sfx : "") +
        " to " +
        range.to +
        (range.sfx ? range.sfx : "")
      );
    });
    strings.splice(0, 0, "Valid Ranges:");
    return strings.join("\n");
  }
  return "No Ranges Found";
}

function sortFunction(c1, c2) {
  if (c1.lineNumber < c2.lineNumber) {
    return -1;
  }
  if (c1.lineNumber > c2.lineNumber) {
    return 1;
  }
  // a must be equal to b
  return 0;
}
